import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

export default function Pilla3() {
  const { t } = useTranslation();
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    axios.get("/api/pilla3-config").then(r => setCfg(r.data)).catch(() => setCfg({}));
  }, []);

  if (!cfg) return <section className="section-light py-12"><div className="max-w-7xl mx-auto px-4">{t("pilla3.cargando")}</div></section>;

  const planes = cfg.planes || [];

  return (
    <section className="section-light py-12" data-testid="pilla3-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="mb-8">
          <div className="divider-red mb-4"></div>
          <h1 className="font-display text-4xl sm:text-6xl" data-testid="pilla3-title">
            {(cfg.titulo || "Pilla3").replace(/3$/, "")}<span className="text-[var(--pc-red)]">3</span>
          </h1>
          <p className="text-neutral-600 mt-2 uppercase tracking-wider text-sm" data-testid="pilla3-subtitle">{cfg.subtitulo}</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
          <div className="rounded-lg overflow-hidden border-4 border-black bg-black aspect-[4/3]">
            <img src={cfg.imagen_url} alt="Pilla3" className="w-full h-full object-cover" data-testid="pilla3-img" />
          </div>

          <div className="space-y-6">
            <p className="text-neutral-800 leading-relaxed whitespace-pre-line" data-testid="pilla3-description">
              {cfg.descripcion}
            </p>

            <div className="grid grid-cols-2 gap-4">
              <div className="bg-black text-white p-5 rounded-lg" data-testid="pilla3-feature-1">
                <div className="text-xs uppercase tracking-widest text-neutral-400 mb-1">{t("pilla3.duracionCerrada")}</div>
                <div className="font-display text-2xl">{cfg.duracion_label}</div>
              </div>
              <div className="bg-black text-white p-5 rounded-lg" data-testid="pilla3-feature-2">
                <div className="text-xs uppercase tracking-widest text-neutral-400 mb-1">{t("pilla3.todoIncluido")}</div>
                <div className="text-sm">{cfg.incluye_label}</div>
              </div>
            </div>

            <div className="border border-neutral-300 rounded-lg overflow-hidden" data-testid="pilla3-tariff-table">
              <div className="bg-[var(--pc-red)] text-white p-4 font-display text-xl">{cfg.tabla_titulo}</div>
              <table className="w-full text-sm">
                <thead className="bg-neutral-100">
                  <tr>
                    <th className="px-4 py-3 text-left uppercase tracking-wider text-xs">{t("pilla3.opcion")}</th>
                    <th className="px-4 py-3 text-left uppercase tracking-wider text-xs">{t("pilla3.eurosMes")}</th>
                    <th className="px-4 py-3 text-left uppercase tracking-wider text-xs">{t("pilla3.kmTotales")}</th>
                    <th className="px-4 py-3 text-left uppercase tracking-wider text-xs">{t("pilla3.costeTotal")}</th>
                  </tr>
                </thead>
                <tbody>
                  {planes.map((p, i) => (
                    <tr key={p.nombre} className={`border-t border-neutral-200 ${i % 2 ? "bg-neutral-50" : ""}`} data-testid={`pilla3-opt-${p.nombre.toLowerCase()}`}>
                      <td className="px-4 py-3 font-semibold">{p.nombre}</td>
                      <td className="px-4 py-3">{p.precio_mes.toFixed(2)} €</td>
                      <td className="px-4 py-3">{p.km_totales.toLocaleString()} km</td>
                      <td className="px-4 py-3 font-semibold">{p.coste_total.toFixed(2)} €</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {cfg.ventaja_comercial && (
              <div className="p-5 rounded-lg bg-[var(--pc-grey)] border-l-4 border-[var(--pc-red)]">
                <div className="text-sm" data-testid="pilla3-ventaja">
                  <strong>{t("pilla3.ventajaComercial")}</strong> {cfg.ventaja_comercial}
                </div>
              </div>
            )}

            <a href={cfg.whatsapp_url} className="btn-red inline-block px-6 py-3" data-testid="pilla3-contact-btn">{t("pilla3.reservarAhora")}</a>
          </div>
        </div>
      </div>
    </section>
  );
}
